import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBubble2Background = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 1025 1024",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M241.254 531.456C262.867 455.859 325.436 378.56 416.32 326.089C565.466 239.979 734.388 253.337 793.617 355.925C852.846 458.513 779.954 611.482 630.808 697.592C495.313 775.82 343.497 771.955 272.433 693.674L110.215 531.456H241.254Z",
		fill: "currentColor",
		strokeWidth: 16,
		stroke: "var(--color-light-blue)"
	})
});
const ForwardRef = forwardRef(SvgBubble2Background);
export default ForwardRef;
